import * as React from "react";

function CircleCheckIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M16.9999 33.6668C7.79492 33.6668 0.333252 26.2052 0.333252 17.0002C0.333252 7.79516 7.79492 0.333496 16.9999 0.333496C26.2049 0.333496 33.6666 7.79516 33.6666 17.0002C33.6666 26.2052 26.2049 33.6668 16.9999 33.6668ZM16.9999 30.3335C20.5361 30.3335 23.9275 28.9287 26.428 26.4283C28.9285 23.9278 30.3333 20.5364 30.3333 17.0002C30.3333 13.4639 28.9285 10.0726 26.428 7.57207C23.9275 5.07159 20.5361 3.66683 16.9999 3.66683C13.4637 3.66683 10.0723 5.07159 7.57183 7.57207C5.07134 10.0726 3.66659 13.4639 3.66659 17.0002C3.66659 20.5364 5.07134 23.9278 7.57183 26.4283C10.0723 28.9287 13.4637 30.3335 16.9999 30.3335ZM15.3383 23.6668L8.26659 16.5952L10.6233 14.2385L15.3383 18.9535L24.7649 9.52516L27.1233 11.8818L15.3383 23.6668Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoCircleCheckIcon = React.memo(CircleCheckIcon);
export default MemoCircleCheckIcon;
